import BasePage from './base-page';
import enhance from './base-page.enhancer';

export default enhance(BasePage);
